import React from 'react';
import { useTableInstance } from '../TableContext/TableContext.js';
import { DownloadButton } from './DownloadButton.js';
/**
 * Renders a button that triggers a download of the current tw-table data.
 *
 * How the data is exported can be customized by passing an `export` function in the column options.
 *
 * A column can be omitted from export using the `disableExport` column option.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { ConnectedDownloadButton, ConnectedTable, DownloadButton, TableProvider } from "@panwds/react-table";
 * ```
 */
export const ConnectedDownloadButton = (props) => {
    const tableInstance = useTableInstance();
    return React.createElement(DownloadButton, { tableInstance: tableInstance, ...props });
};
//# sourceMappingURL=ConnectedDownloadButton.js.map